module.exports = __webpack_public_path__ + "media/images/xpass/icons/favorite-selected-00174097eb86a4d9a9342c57e34b000d.svg";